/* eslint-disable max-len */
import React from "react";
import Card from "../common/Card/Card";
import Skeleton from "../common/Skeleton/Skeleton";

interface Props {
    className?: string;
}

const SkeletonGraph = ({ className }: Props) => (
    <Card padding="large" className={className}>
        <div className="flex flex-col gap-2 animate-pulse ">
            <div className="space-y-1 mb-1">
                <Skeleton width="6rem" />
            </div>
            <div>
                <svg
                    preserveAspectRatio="none"
                    width="878"
                    height="191"
                    viewBox="0 0 878 191"
                    fill="none"
                    className="text-pine-700"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        width: "100%",
                        height: "13rem",
                    }}
                >
                    <rect width="35" height="11" rx="1" />
                    <rect y="37" width="35" height="11" rx="1" />
                    <rect y="74" width="35" height="11" rx="1" />
                    <rect y="111" width="22" height="11" rx="1" />
                    <rect y="148" width="12" height="11" rx="1" />
                    <path d="M58 6C58 3.23858 60.2386 1 63 1H77C79.7614 1 82 3.23858 82 6V172H58V6Z" />
                    <path d="M86 60C86 57.2386 88.2386 55 91 55H105C107.761 55 110 57.2386 110 60V172H86V60Z" />
                    <rect x="65" y="180" width="38" height="11" rx="1" />
                    <path d="M146.875 38C146.875 35.2386 149.114 33 151.875 33H165.875C168.636 33 170.875 35.2386 170.875 38V172H146.875V38Z" />
                    <path d="M174.875 52C174.875 49.2386 177.114 47 179.875 47H193.875C196.636 47 198.875 49.2386 198.875 52V172H174.875V52Z" />
                    <rect x="153.875" y="180" width="38" height="11" rx="1" />
                    <path d="M235.75 131C235.75 128.239 237.989 126 240.75 126H254.75C257.511 126 259.75 128.239 259.75 131V172H235.75V131Z" />
                    <path d="M263.75 110C263.75 107.239 265.989 105 268.75 105H282.75C285.511 105 287.75 107.239 287.75 110V172H263.75V110Z" />
                    <rect x="240.25" y="180" width="43" height="11" rx="1" />
                    <path d="M340.625 73C340.625 70.2386 342.864 68 345.625 68H359.625C362.386 68 364.625 70.2386 364.625 73V172H340.625V73Z" />
                    <rect x="324.625" y="180" width="56" height="11" rx="1" />
                    <path d="M424.5 48C424.5 45.2386 426.739 43 429.5 43H443.5C446.261 43 448.5 45.2386 448.5 48V172H424.5V48Z" />
                    <rect x="417.5" y="180" width="38" height="11" rx="1" />
                    <path d="M512.375 162C512.375 159.239 514.614 157 517.375 157H531.375C534.136 157 536.375 159.239 536.375 162V172H512.375V162Z" />
                    <rect x="492.375" y="180" width="64" height="11" rx="1" />
                    <path d="M614.25 164C614.25 161.239 616.489 159 619.25 159H633.25C636.011 159 638.25 161.239 638.25 164V172H614.25V164Z" />
                    <rect x="593.25" y="180" width="66" height="11" rx="1" />
                    <path d="M726.625 95C726.625 92.2386 728.864 90 731.625 90H745.625C748.386 90 750.625 92.2386 750.625 95V172H726.625V95Z" />
                    <rect x="696.125" y="180" width="85" height="11" rx="1" />
                    <path d="M828 80C828 77.2386 830.239 75 833 75H847C849.761 75 852 77.2386 852 80V172H828V80Z" />
                    <rect x="818" y="180" width="44" height="11" rx="1" />
                </svg>
            </div>

            <div className="flex gap-2 max-w-full overflow-auto hide-scrollbar">
                <div className="flex gap-0.5">
                    <Skeleton width="3rem" />
                    <Skeleton width="1rem" />
                </div>
                <div className="flex gap-0.5">
                    <Skeleton width="3rem" />
                    <Skeleton width="1rem" />
                </div>
                <div className="flex gap-0.5">
                    <Skeleton width="3rem" />
                    <Skeleton width="1rem" />
                </div>
                <div className="flex gap-0.5">
                    <Skeleton width="3rem" />
                    <Skeleton width="1rem" />
                </div>
            </div>
        </div>
    </Card>
);

export default SkeletonGraph;
